module.exports = __webpack_public_path__ + "img/东风汽车@2x.de385be1.png";